export const basketApiUrl = 'basketapi/api/v1/basket';
